import React, { useState } from "react";
import ProductIcon from "../../../../../images/common/product.svg";
import ServiceIcon from "../../../../../images/common/service.svg";
import DonationIcon from "../../../../../images/donation/donating-hands.svg";
import MembershipIcon from "../../../../../images/common/ball-trio.svg";
import LockIcon from "../../../../../images/products/yellow-lock.svg"; 
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import { BoxWrapper } from "../styles";

class ItemData {
  icon: string;
  name: string;
  showLock: boolean;
  constructor(data?: Partial<ItemData>) {
    this.icon = data?.icon || "";
    this.name = data?.name || "";
    this.showLock = data?.showLock === true;
  }
}

const data: ItemData[] = [
  new ItemData({
    name: "Product",
    icon: ProductIcon,
    showLock: false,
  }),
  new ItemData({
    name: "Service",
    icon: ServiceIcon,
    showLock: false,
  }),
  new ItemData({
    name: "Donation",
    icon: DonationIcon,
    showLock: false,
  }),
  new ItemData({
    name: "Membership",
    icon: MembershipIcon,
    showLock: false,
  }),
];

const ItemTypeBoxes = () => {
  const [activeIndex, setActive] = useState(-1);
  return (
    <>
      <FlexContainer spacing={60} fxLayout="column">
        <CustomLabel className="content-label-primary">Main Items</CustomLabel>
        <FlexContainer spacing={25}>
          {data &&
            data.map((d, idx) => {
              const isActive = activeIndex === idx;
              return (
                <BoxWrapper
                  active={isActive}
                  key={idx}
                  onClick={() => setActive(idx)}
                >
                  {d.showLock && (
                    <img className="item-locked" src={LockIcon} alt="icon" />
                  )}
                  <img src={d.icon} alt="icon" />
                  <CustomLabel>{d.name}</CustomLabel>
                </BoxWrapper>
              );
            })}
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

export default ItemTypeBoxes;
